<template>
  <div class="wrapper">
    <div class="typing-demo">
      <p :id="`typewriter${typewriterId}`" class="blink-cursor"></p>
    </div>
  </div>
</template>

<script>

export default {
  name: "TypewriterText",
  props: {
    text: {
      type: String,
      required: true
    },
    delay: {
      type: Number,
      required: false
    },
    typewriterId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    typewriterTimeout: null,
    i: 0,
    speed: 500
  }),
  emits: ['complete'],
  methods: {
    typeWriter() {
      if (this.i < this.$props.text.length) {
        document.getElementById(`typewriter${this.$props.typewriterId}`).innerHTML += this.$props.text.charAt(this.i);
        this.i++;
        this.speed = this.speed - 50;
        this.typewriterTimeout = setTimeout(this.typeWriter, this.speed);
      } else {
        this.$emit('complete');
      }
    }
  },
  mounted() {
    if (this.$props.delay) {
      setTimeout(this.typeWriter, this.$props.delay);
    }
  },
  destroyed() {
    clearTimeout(this.typewriterTimeout);
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/base.variables";
@import "~@/assets/css/base.animations";

.typing-demo {

}

/** Desktop styling **/
@media screen and (min-width: $screen-md) {

}
</style>
